export const navigation = {
  'Go back': 'Zurück',
  'Go forward': 'Vorwärts',
};
